import { Menu } from "@mui/material";
import { useDispatch } from "react-redux";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  PrimaryButton,
  Reject,
  Accept,
  AcceptUpload,
  PrimaryLoadingButton,
  CancelButton,
} from "../../css components/Button";
import pages from "../../../constants/pages";
import DropDownMenu from "./DropDownMenu";
import { useAxios } from "../../../hooks";
import { alert } from "../../../redux/slices/alertSlice";
import ConfirmPopUp from "./campaign form components/ConfimPopUp";
import LockCampaignDialog from "./campaign form components/LockCampaignDialog";

let backStatus = ["ACTIVE", "INITIATED", "FAILED", "EXPIRED"];

export default function CampaignButtons({
  editState,
  setAudienceData,
  setEditState,
  liveUsers,
  formikProps,
  component,
  brandIdentity,
  setTakeUpOffer,
  setDialogUploadCSV,
}) {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  console.log(loading);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const [confirmPopUp, setConfirmPopUp] = useState({ state: false });
  const [dialogState, setDialogState] = useState({ data: {}, state: false });

  return (
    <Fragment>
      {!formikProps.values?.campaignIsEditable && (
        <CancelButton
          variant="outlined"
          onClick={() => {
            if (component === "") {
              navigate(pages.myCampaign.route);
            }
            if (component === "request") {
              navigate(pages.campaignRequest.route);
            }
          }}
        >
          Back
        </CancelButton>
      )}

      {/* {component === "" &&
        formikProps.values?.campaignID &&
        formikProps.values?.status === "ACTIVE" &&
        formikProps.values.permissionSettings.display_stats && (
          <PrimaryButton
            style={{ marginLeft: "5px" }}
            onClick={() =>
              navigate(
                pages.analytics.route +
                  formikProps.values.campaignID +
                  "?campaignName=" +
                  formikProps.values?.campaign_name?.value
              )
            }
            variant="contained"
          >
            Analytics
          </PrimaryButton>
        )} */}
      {/* note added  */}

      {formikProps.values.campaignID &&
        !editState &&
        formikProps.values?.campaign_status === "CREATED" && (
          <PrimaryButton
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setDialogState({
                state: true,
                data: formikProps.values,
                component: "lockCampaign",
              });
            }}
            variant="contained"
          >
            Lock my Campaign
          </PrimaryButton>
        )}

      {component === "" &&
        formikProps.values.campaignID &&
        (formikProps.values?.campaign_status === "OFFER_ACCEPTED" ||
          formikProps.values?.campaign_status === "PARTIAL_ACCEPTED" ||
          formikProps.values?.campaign_status === "ACCEPTED" ||
          formikProps.values?.campaign_status === "REJECTED" ||
          formikProps.values?.campaign_status === "PARTIAL_REJECTED") && (
          <PrimaryLoadingButton
            disabled={!formikProps.values.isReadyMyCampaign}
            style={{ marginLeft: "5px" }}
            loading={loading}
            onClick={() => {
              setConfirmPopUp({
                state: true,
                data: {
                  content: "Ready Campaign",
                  handleFunction: handleReadyCampaign,
                },
              });
            }}
            variant="contained"
          >
            Ready my Campaign
          </PrimaryLoadingButton>
        )}

      {formikProps.values.campaignID &&
        component === "" &&
        formikProps.values.campaign_status === "READY" &&
        parseInt(formikProps?.values?.Intersection_Audience) > 0 && (
          <PrimaryLoadingButton
            disabled={formikProps.values.campaignLaunched}
            style={{ marginLeft: "5px" }}
            loading={loading}
            onClick={() => {
              setConfirmPopUp({
                state: true,
                data: {
                  content: "Launch Campaign",
                  handleFunction: handleLaunchCampaign,
                },
              });
            }}
            variant="contained"
          >
            Launch Campaign
          </PrimaryLoadingButton>
        )}
      {formikProps.values.campaignID &&
        component === "" &&
        (formikProps.values.status === "ACTIVE" ||
          formikProps.values.status === "COMPLETED") && (
          <PrimaryLoadingButton
            style={{ marginLeft: "5px" }}
            loading={loading}
            onClick={() => {
              navigate(
                pages.campaignAnalytics.route + formikProps.values.campaignID
              );
            }}
            variant="contained"
          >
            View Analytics
          </PrimaryLoadingButton>
        )}

      {component === "superadmin" && (
        <Accept size="large" variant="contained">
          Approve Campaign
        </Accept>
      )}

      {brandIdentity &&
        component !== "accepted" &&
        formikProps.values.status !== "ACTIVE" &&
        formikProps.values.campaignStatus !== "MISSED" &&
        formikProps.values.campaignStatus !== "INITIATED" &&
        formikProps.values.campaignStatus !== "READY" &&
        formikProps.values.campaignStatus !== "Expired" &&
        formikProps.values.individualCampaignStatus !== "ACCEPTED" &&
        formikProps.values.individualCampaignStatus !== "OFFER_ACCEPTED" &&
        formikProps.values.individualCampaignStatus !== "REJECTED" &&
        formikProps.values.requestStatus !== "ACCEPTED" &&
        formikProps.values.requestStatus !== "OFFER_ACCEPTED" &&
        formikProps.values.requestStatus !== "REJECTED" && (
          <Fragment>
            <Reject
              style={{ marginLeft: "5px" }}
              size="large"
              variant="contained"
              disabled={formikProps.values.campaignStatus === "Expired"}
              onClick={() =>
                setTakeUpOffer((prevVal) => ({
                  ...prevVal,
                  action: "REJECTED",
                  state: true,
                }))
              }
            >
              Reject
            </Reject>

            <Accept
              style={{ marginLeft: "5px" }}
              size="large"
              variant="contained"
              disabled={
                parseInt(liveUsers?.liveUser) <= 0 ||
                !liveUsers.liveUser ||
                formikProps.values.campaignStatus === "Expired"
              }
              onClick={() =>
                setTakeUpOffer((prevVal) => ({
                  ...prevVal,
                  action: "ACCEPTED",
                  state: true,
                }))
              }
            >
              Accept
            </Accept>
          </Fragment>
        )}

      {(formikProps.values.status === "ACTIVE" ||
        formikProps.values.status === "COMPLETED") &&
        component === "request" && (
          <Fragment>
            <PrimaryLoadingButton
              variant="outlined"
              size="large"
              loading={loading}
              sx={{
                marginLeft: "5px",
                whiteSpace: "nowrap",
              }}
              onClick={(event) => {
                if (component === "") {
                  setMenuAnchor(event.currentTarget);
                }

                if (component === "request") {
                  handleDownloadReport();
                }
              }}
            >
              Report
            </PrimaryLoadingButton>

            <Menu
              style={{ marginTop: "10px" }}
              open={!!menuAnchor}
              anchorEl={menuAnchor}
              onClose={() => setMenuAnchor(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <DropDownMenu
                formikProps={formikProps}
                setLoading={setLoading}
                setMenuAnchor={setMenuAnchor}
              />
            </Menu>
          </Fragment>
        )}

      {component === "request" &&
        formikProps.values.csvUpload &&
        (formikProps.values.campaignStatus === "REQUESTED" ||
          formikProps.values.campaignStatus === "REJECTED") && (
          <AcceptUpload
            style={{ marginLeft: "5px" }}
            variant="contained"
            onClick={() => setDialogUploadCSV(true)}
          >
            UPLOAD ACCEPT
          </AcceptUpload>
        )}

      <LockCampaignDialog
        setEditState={setEditState}
        dialogState={dialogState}
        setDialogState={setDialogState}
        formikProps={formikProps}
        setAudienceData={setAudienceData}
      />

      <ConfirmPopUp
        dialogState={confirmPopUp}
        setDialogState={setConfirmPopUp}
      />
    </Fragment>
  );

  function handleLaunchCampaign() {
    setLoading(true);
    axios({
      url: "/user/launchCampaign",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: formikProps.values.campaignID,
      },
    })
      .then(function (response) {
        if (response.status) {
          formikProps.setValues((prev) => ({
            ...prev,
            campaignStatus: response.data?.status,
            campaign_status: response.data?.campaign_status,
          }));

          setEditState(false);
          dispatch(
            alert({
              type: "success",
              message: response.message.displayMessage,
            })
          );
          setLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleReadyCampaign() {
    setLoading(true);
    axios({
      url: "/user/readyCampaign",
      method: "POST",
      disableRedirect: true,
      data: { campaign_id: formikProps.values.campaignID },
    })
      .then((response) => {
        if (response.status) {
          formikProps.setValues((prev) => ({
            ...prev,
            status: response?.data?.status,
            campaignStatus: response.data?.status,
            campaign_status: response.data?.campaign_status,
            audienceMessage: "Processing...",
          }));
          dispatch(
            alert({
              type: "success",
              message: response.message.displayMessage,
            })
          );
          setLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleDownloadReport() {
    setLoading(true);
    let url = "/brand/campaign/report/" + formikProps.values?.campaignID;
    if (component === "request") {
      url = "/contributer/campaign/report/" + formikProps.values?.campaignID;
    }

    axios({
      url: url,
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          if (response?.data?.reportUrl) {
            window.open(response?.data?.reportUrl, "_blank");
            dispatch(
              alert({
                type: "success",
                message: "Report was successfully downloaded.",
              })
            );
          }
        }

        if (response?.data?.errors) {
          dispatch(
            alert({
              type: "success",
              message: response?.data?.errors,
            })
          );
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }
}
